// extracted by mini-css-extract-plugin
export var actionIcon = "_ri-0";